module.exports = __webpack_public_path__ + "img/album07_35.ccaaab99.jpg";